module.exports = __webpack_public_path__ + "img/logo-sovalis-white.687b1ed1.svg";